export default "__VITE_ASSET__492ecefd__"